import axios from 'axios';

const basePath = 'https://instasolv.com:3500';

function searchQuestions(params) {
    var query = '';
    for (var key in params) {
        if (params[key] !== 'select' && params[key] != '')
            query += key + "=" + params[key] + "&"
    };

    return axios.get(basePath + '/search?' + query.substring(0, query.length - 1))
        .then((response) => {
            return response.data
        })
}

function getFilters() {
    return axios.get(basePath + '/getFilters')
        .then((response) => {
            return response.data
        })
}

function publishQuestions(questions) {
    return axios.post(basePath + '/question/manage', { questions: questions })
        .then((response) => {
            return response.data
        })
}

function updateQuestion(question) {
    return axios.post(basePath + '/question/update', { question })
        .then((response) => {
            return response.data
        })
}

function bulkPublish(data) {
    return axios.post(basePath + '/bulkPublish', data)
        .then((response) => {
            return response.data
        })
}

function downloadSerchResultCSV(param) {
    return axios.get(basePath + '/search?' + getQueryForCompleteCSV(param))
        .then((response) => {
            return response.data
        })
}

function getQueryForCompleteCSV(params) {
    var query = '';
    for (var key in params) {
        if (key !== 'limit' && key !== 'page' && params[key] !== 'select' && params[key] != '')
            query += key + "=" + params[key] + "&"
    };
    return query.substring(0, query.length - 1);
}

// function fetchSolutionText(solutionId, callback) {
//     return axios.get(basePath + `/question/extractSolText?solutionId=${solutionId}`)
//         .then((response) => {
//             callback(response.data);
//             return response.data
//         })
// }

function fetchSolutionText(solution_url, callback) {
    const headers = {
        'app_id': 'aditya_singhal_transtutors_com',
        'app_key': 'ac4ccf6302303d331341',
        'content_type': 'application/json'
    };
    const data = {
        src: solution_url,
        "formats": ["text", "data"],
        "data_options": {
            "include_latex": true,
            "include_table_html": true,
            "include_mathml": true,
            "include_asciimath": true,
            "include_tsv": true,
            "include_svg": true
        }
    }
    return axios.post('https://api.mathpix.com/v3/text', data, { headers: headers })
        .then((response) => {
            callback(response.data);
            return response.data
        })
}

export const publishServices = {
    searchQuestions,
    getFilters,
    publishQuestions,
    updateQuestion,
    bulkPublish,
    downloadSerchResultCSV,
    fetchSolutionText
};